import { useEffect, useState } from "react";
import { Routes, Route, Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

import All from "./all";
import User from "./user";
import Detailed from "./detailed";

export default function Activity() {
  const user = useSelector((state) => state.Auth.user);
  const businessUnit = useSelector((state) => state.Auth.businessUnit);

  return (
    <div className="px-4 md:px-6 py-5 space-y-5 bg-[#faf8f5] min-h-screen">
      <div className="overflow-x-auto">
        <nav className="bg-white rounded-lg flex items-center gap-1 w-fit border border-gray-200 p-1 shadow-sm">
          <TabItem key="user" href="/activity" title="User" />
          <TabItem key="all" href="/activity/all" title="All people" />
          {(user.role === "admin" || user.role === "super_admin") && <TabItem key="detailed" href="/activity/detailed" title="Detailed" />}
        </nav>
      </div>
      <Routes>
        <Route path="/" element={<User />} />
        <Route path="/user" element={<User />} />
        <Route path="/all" element={<All key={businessUnit?._id} businessUnit={businessUnit} />} />
        <Route path="/detailed" element={<Detailed key={businessUnit?._id} businessUnit={businessUnit} />} />
      </Routes>
    </div>
  );
}

const TabItem = ({ href, title }) => {
  const location = useLocation();
  const [active, setActive] = useState(false);

  useEffect(() => {
    setActive(location.pathname === href);
  }, [location.pathname]);

  return (
    <Link
      to={href}
      className={`relative rounded-md py-2 px-5 flex items-center gap-2 text-sm font-medium transition-all duration-200
        ${active ? "bg-blue-600 text-white shadow-sm" : "text-gray-600 hover:text-gray-900 hover:bg-gray-50"}`}>
      <span className="truncate">{title}</span>
    </Link>
  );
};
